import { connect, LocalDataTrack } from 'twilio-video';
import Services from './services';
import toast from 'react-hot-toast';

export const Token = async (userId, roomName, chatSID, participantName) => {
  try {
    const res = await Services.twilio_service(
      userId,
      roomName,
      chatSID,
      participantName
    );
    const token = res.data.token || null;
    return token;
  } catch (error) {
    toast.error('Please check your internet');
    return null;
  }
};

export const VideoNBoxChatToken = async (
  userId,
  roomName,
  chatSID,
  participantName
) => {
  try {
    const [res1, res2] = await Promise.all([
      Services.twilio_video_service(userId, roomName, chatSID, participantName),
      Services.twilio_only_box_text_chat_service(
        userId,
        chatSID,
        participantName
      ),
    ]);

    // const res = await Services.twilio_video_service(
    //   userId,
    //   roomName,
    //   chatSID,
    //   participantName
    // );
    const videoToken = res1.data?.token || null;
    const boxChatToken = res2.data?.token || null;
    return [videoToken, boxChatToken];
  } catch (error) {
    toast.error('Please check your internet');
    return null;
  }
};

export const GlobalChatToken = async (userId, chatSID, participantName) => {
  try {
    const res = await Services.twilio_global_chat_service(
      userId,
      chatSID,
      participantName
    );
    const token = res.data.token || null;
    return token;
  } catch (error) {
    toast.error('Please check your internet');
    return error;
  }
};

export const getNewBoxChatToken = async (userId, chatSID, participantName) => {
  try {
    const res = await Services.twilio_only_box_text_chat_service(
      userId,
      chatSID,
      participantName
    );
    const token = res.data.token || null;
    return token;
  } catch (error) {
    toast.error('Please check your internet');
    return error;
  }
};

export const TwilioConnect = async (token, roomName) => {
  try {
    const room = await connect(token, {
      name: roomName,
      audio: true,
      video: true,
    });
    return { room, success: true };
  } catch (error) {
    console.log('error in connecting twilio', error);
    if (error.message === 'Permission denied') {
      alert(
        'Please check site settings and enable audio, video permissions for this website.'
      );
      return { error, success: false };
    } else {
      alert(`Error: ${error.message}`);
      return { error, success: false };
    }
  }
};

export const connectTextOnlyChat = async (token, roomName) => {
  try {
    const msgTrack = await new LocalDataTrack();
    const room = await connect(token, {
      name: roomName,
      audio: false,
      video: false,
      tracks: [msgTrack],
    });
    return { room, msgTrack, success: true };
  } catch (error) {
    console.log('error in publishing data track', error);
    return { error, success: false };
  }
};

export const establishEventListeners = (
  participant,
  trackpubsToTracks,
  setVideoTracks,
  setAudioTracks,
  setVideoEnabled
) => {
  setVideoTracks(trackpubsToTracks(participant.videoTracks));
  setAudioTracks(trackpubsToTracks(participant.audioTracks));

  const trackSubscribed = (track) => {
    if (track.kind === 'video') {
      handleTrackOnOff(track);
      setVideoEnabled(track.isEnabled);
      setVideoTracks((videoTracks) => [...videoTracks, track]);
    } else if (track.kind === 'audio') {
      setAudioTracks((audioTracks) => [...audioTracks, track]);
    } else if (track.kind === 'data') {
    }
  };

  const trackUnsubscribed = (track) => {
    if (track.kind === 'video') {
      setVideoTracks((videoTracks) => videoTracks.filter((v) => v !== track));
    } else if (track.kind === 'audio') {
      setAudioTracks((audioTracks) => audioTracks.filter((a) => a !== track));
    }
  };

  const handleTrackOnOff = (track) => {
    track.on('disabled', () => {
      setVideoEnabled(false);
    });

    track.on('enabled', () => {
      setVideoEnabled(true);
    });
  };

  participant.on('trackSubscribed', trackSubscribed);
  participant.on('trackUnsubscribed', trackUnsubscribed);

  participant.on('subscribed', trackSubscribed);

  participant.tracks.forEach((publication) => {
    if (publication.isSubscribed) {
      if (publication.track.kind === 'video') {
        setVideoEnabled(publication.track.isEnabled);
        handleTrackOnOff(publication.track);
      }
    }
  });
};

export const removeAllListeners = (participant) => {
  participant.removeAllListeners();
};

export const globalEstablishEventListeners = (
  globalParticipant,
  setGlobalMessages
) => {
  const trackSubscribed = (track) => {
    if (track.kind === 'data') {
      track.on('message', (data) => {
        const name = globalParticipant.identity;
        const msgObj = {
          name: name,
          comment: data,
        };
        setGlobalMessages((prevMsgs) => [...prevMsgs, msgObj]); //make msgs a object
      });
    }
  };

  const trackUnsubscribed = (track) => {};

  globalParticipant.on('trackSubscribed', trackSubscribed);
  globalParticipant.on('trackUnsubscribed', trackUnsubscribed);

  globalParticipant.on('subscribed', trackSubscribed);
};

export const globalRemoveAllListeners = (globalParticipant) => {
  globalParticipant.removeAllListeners();
};
